"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AppBreadcrumb = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _antd = require("antd");

var _NavigationConfig = _interopRequireDefault(require("../../configs/NavigationConfig"));

var _IntlMessage = _interopRequireDefault(require("../../components/util-components/IntlMessage"));

var breadcrumbData = {
  '/app': /*#__PURE__*/_react.default.createElement(_IntlMessage.default, {
    id: "home"
  })
};

_NavigationConfig.default.forEach(function (elm, i) {
  var assignBreadcrumb = function assignBreadcrumb(obj) {
    return breadcrumbData[obj.path] = /*#__PURE__*/_react.default.createElement(_IntlMessage.default, {
      id: obj.title
    });
  };

  assignBreadcrumb(elm);

  if (elm.submenu) {
    elm.submenu.forEach(function (elm) {
      assignBreadcrumb(elm);

      if (elm.submenu) {
        elm.submenu.forEach(function (elm) {
          assignBreadcrumb(elm);
        });
      }
    });
  }
});

var BreadcrumbRoute = (0, _reactRouterDom.withRouter)(function (props) {
  var location = props.location;
  var pathSnippets = location.pathname.split('/').filter(function (i) {
    return i;
  });
  var buildBreadcrumb = pathSnippets.map(function (_, index) {
    var url = "/".concat(pathSnippets.slice(0, index + 1).join('/'));
    return /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb.Item, {
      key: url
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: url
    }, breadcrumbData[url]));
  });
  return /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb, null, buildBreadcrumb);
});

var AppBreadcrumb = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AppBreadcrumb, _Component);

  var _super = (0, _createSuper2.default)(AppBreadcrumb);

  function AppBreadcrumb() {
    (0, _classCallCheck2.default)(this, AppBreadcrumb);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(AppBreadcrumb, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(BreadcrumbRoute, null);
    }
  }]);
  return AppBreadcrumb;
}(_react.Component);

exports.AppBreadcrumb = AppBreadcrumb;
var _default = AppBreadcrumb;
exports.default = _default;